import { getSiteConfig } from '@shared/config';
import { z } from 'zod';

function createRegistrationAddressSchema(t: (key: string) => string) {
  const market = getSiteConfig().REGISTRATION;
  const stateSchema = market.showsStateSelect ? z.string().min(1, t('validation.address.state')) : z.string().optional();

  return z.object({
    houseNameNumber: z.string().min(1, t('validation.address.houseNameNumber')),
    streetName: z.string().min(1, t('validation.address.streetName')),
    line2: z.string().optional(),
    city: z.string().min(1, t('validation.address.city')),
    state: stateSchema,
    postcode: z
      .string()
      .min(1, t('validation.address.postcode.required'))
      .regex(market.postcodePattern, t('validation.address.postcode.invalid'))
      .transform(val => val.toUpperCase().replace(/\s/g, '')),
    buildingName: z.string().optional(),
    buildingNumber: z.string().optional(),
    street: z.string().optional(),
  });
}

export { createRegistrationAddressSchema };
